import './Features.scss';
import imgDatabase from '../../images/icons/database-cloud-circle.png';
import imgPlay from '../../images/icons/play-circle.png';
import imgPdf from '../../images/icons/file-pdf.png';
import imgMobile from '../../images/icons/smartphone.png';

const features = [
  {
    icon: (
      <img src={imgDatabase} alt="Database Cloud" />
    ),
    title: 'HWP 자동 DB화',
    description: '미주 처리된 HWP 파일을 자동으로 데이터베이스화하고 단원명을 쉽게 매칭할 수 있습니다.',
  },
  {
    icon: (
      <img src={imgPlay} alt="Play Circle" />
    ),
    title: '다양한 출제 기능',
    description: '수동출제, 자동출제, 시험지저장, 미리보기, 프린트, 채점, 오답노트 등 방대한 기능을 탑재했습니다.',
  },
  {
    icon: (
      <img src={imgPdf} alt="File PDF" />
    ),
    title: 'PDF 통합 지원',
    description: 'PDF도 한글과 통합하여 DB를 구축할 수 있고, 프린트 시 고퀄리티로 글자가 깨지지 않습니다.',
  },
  {
    icon: (
      <img src={imgMobile} alt="Smartphone" />
    ),
    title: '모바일 앱 지원',
    description: '안드로이드, 아이폰에서 시험응시 및 동영상 학습이 가능하며 누적된 시험을 통한 오답관리가 가능합니다.',
  },
];

const Features = () => {
  return (
    <section id="features" className="features section">
      <div className="container">
        <header className="features__header">
          <h2 className="features__title">문제은행 구축 솔루션 소개</h2>
          <div className="features__description">
            <p>아래한글 기반 디비구축의 독보적인 기술력을 가진 매쓰오토젠<span className='italic'>!</span></p>
            <p>방대한 기능의 집합체, 만물 백화점처럼 없는 게 없는 문제은행 솔루션<span className='italic'>!</span></p>
            <p>정기 업데이트를 통해 더욱 강력하게 진화하면서 정확한 DB 구축을 지원합니다<span className='italic'>!</span></p>
          </div>
          <div className="features__notice">
            <p>개발자가 개발에 전념하느라 사이트에 모든 내용을 담지 못한 점 양해 바랍니다.</p>
            <p>문의를 통해서 필요한 기능이 과연 없는지 확인해주세요.</p>
              <p>준비되어 있는 선생님처럼 준비된 개발자이기 때문에 자신 있습니다.</p>
          </div>
          
        </header>

        <div className="features__grid">
          {features.map((feature, index) => (
            <article key={index} className="features__card">
              <div className="features__icon">{feature.icon}</div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-description">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

